import { memo } from 'react';
import Typography from '@mui/material/Typography';
// Local files
import { Root } from './Info.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import { patientsSelectors } from 'features/patients';

const Info = () => {
  const patient = useCustomSelector(patientsSelectors.getPatientData);

  return (
    <Root>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`First Name: ${patient?.first_name ? patient?.first_name : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Last Name: ${patient?.last_name ? patient?.last_name : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Email: ${patient?.email ? patient?.email : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Phone: ${patient?.phone ? patient?.phone : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Gender: ${patient?.gender ? patient?.gender : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Birth At: ${patient?.birth_at ? patient?.birth_at.substring(0, patient?.birth_at.indexOf('T')) : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Source: ${patient?.source ? patient?.source : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Language: ${patient?.language ? patient?.language : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Street Address: ${patient?.street_address ? patient?.street_address : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`City: ${patient?.city ? patient?.city : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`State: ${patient?.state ? patient?.state : 'No info'}`}</Typography>
      <Typography variant='subtitle1' component='div' sx={{ whiteSpace: 'pre-wrap' }}>{`Zip: ${patient?.zip ? patient?.zip : 'No info'}`}</Typography>
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Info {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);